import React, { useState } from "react";
import Header from "../../components/header2";
import {
  Container,
  Grid,
  Paper,
  Slider,
  OutlinedInput,
  InputAdornment,
} from "@material-ui/core";
import { useStyles, PriceSlider } from "./style";
import { Search } from "@material-ui/icons";
import BrandItem from "./components/brandItem";
import MainItem from "./components/mainItem";

export default function CompareProducts() {
  const classes = useStyles();
  const [priceRange, setPriceRange] = useState([2000, 250000]);
  // Set price range
  const handleChange = (event, newValue) => {
    setPriceRange(newValue);
  };

  return (
    <div className={classes.root}>
      <div style={{ backgroundColor: "#000" }}>
        <Header />
      </div>
      <Container className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <p className={classes.heading}>Filters</p>
            <Paper className={classes.paper}>
              <p className={classes.text}>Price (global media value)</p>
              <PriceSlider
                value={priceRange}
                min={2000}
                max={250000}
                onChange={handleChange}
                aria-labelledby="range-slider"
              />
              <div className={classes.priceRow}>
                <p className={classes.rp}>{priceRange[0]} IND</p>
                <p className={classes.rp}>{priceRange[1]} IND</p>
              </div>
            </Paper>
            <Paper>
              <OutlinedInput
                id="outlined-adornment-password"
                type="text"
                name="text"
                placeholder="Search brand..."
                className={classes.input}
                startAdornment={
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                }
                labelWidth={0}
              />
              <div className={classes.brand}>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => {
                  return <BrandItem />;
                })}
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={9}>
            <p className={classes.heading2}>Smartphone comparison (12)</p>
            <Grid container>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => {
                return (
                  <Grid item xs={12} md={4}>
                    <MainItem />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
